// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__f0whQ","additionalInfo":"AgreementModal_additionalInfo__2cAyV"};